<div class="componentdiv concepts-container">
  <div class="concepts-content">
    <header class="concepts-header">
      <h2>The key concepts of <span class="brand-bold">Your</span>Notes</h2>
      <p class="intro-text">
        Streamline your workflow by connecting meetings, notes, and tasks in one seamless experience.
      </p>
    </header>

    <div class="concepts-grid">
      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>calendar_month</mat-icon></div>
        <h4>Connect your calendar</h4>
        <p>Release the full power by linking Google or Microsoft calendars. See upcoming events and sync your schedule effortlessly.</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>dashboard</mat-icon></div>
        <h4>Unified Dashboard</h4>
        <p>Get a crystal-clear overview of all your connected calendars and pending tasks in one place. Your entire day, organized at a single glance.</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>edit_note</mat-icon></div>
        <h4>Create notes</h4>
        <p>Organize notes in folders. For recurring meetings, YourNotes automatically finds your previous context so you never miss a beat.</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>checklist</mat-icon></div>
        <h4>Create tasks</h4>
        <p>Define tasks directly from your notes. Tasks remain linked to their original note, keeping your context just one click away.</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>search</mat-icon></div>
        <h4>Search your notes</h4>
        <p>Find exactly what you need with our powerful keyword search. Your growing library of knowledge remains accessible forever.</p>
      </div>

      <div class="feature-card">
        <div class="icon-wrapper"><mat-icon>share</mat-icon></div>
        <h4>Share your notes</h4>
        <p>Keep colleagues in the loop. Quickly share meeting summaries via email with a single click.</p>
      </div>
    </div>

    <div class="support-footer">
      <p>Need more details? Visit our <a class="links" routerLink="/support">support pages</a>.</p>
    </div>
  </div>

  <mat-toolbar class="bottom-toolbar">
    <button mat-flat-button color="primary" (click)="back()">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
  </mat-toolbar>
</div>